/* eslint-disable */
import axios from 'axios'

// axios.defaults.withCredentials = true
axios.interceptors.request.use(config => {
    // config.headers['content-type'] = ['application/json;charset=UTF-8','application/x-www-form-urlencoded;charset=UTF-8','multipart/form-data'];
    if (config.data instanceof Object) config.headers['content-type'] = 'application/json;charset=UTF-8'
    if (config.data instanceof FormData) config.headers['content-type'] = 'multipart/form-data'
    return config
}, error => {
    Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/axios/index.js